// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container/styles/Container';
import { AnimatedContainer } from '../../../common/styles/animatedContainer/styles/AnimatedContainer';
// Styles
import { breathingAnimation } from '../styles/breathingAnimation';
/**
 * A wrapper to contain a breathing dot within a boundary
 *
 * @param {BreathingDotProps} props
 */
export var BreathingDot = function (_a) {
    var delay = _a.delay;
    return (React.createElement(Container, { "data-testid": 'breathingDot', width: '4px', height: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
        React.createElement(AnimatedContainer, { display: 'block', borderRadius: '50%', backgroundColor: '#cccccc', height: '3px', width: '3px', animate: breathingAnimation(delay) })));
};
//# sourceMappingURL=BreathingDot.js.map